/* globals require, snowdome, window, $, jQuery, Modernizr */

/**
 * A coupon with a balance that can be applied as a discount to the total
 * @typedef {Object} Coupon
 * @property {string} code - Coupon code
 * @property {Number} balance - Total amount that can be redeemed
 * @property {Date} expiry - Expiry date
 */

var termsAlert,
	$termsAccepted,
	$sidebar;

window.snowdome = window.snowdome || {};

window.snowdome.Checkout = {
	total: 0,

	init: function() {
		'use strict';

		var that = this;

		$termsAccepted = $('[data-terms]');
		$sidebar = $('#checkout__sidebar');
		this.total = $('#checkout__total').data('total');

		$('select').chosen({
			width: '100%',
			disable_search: true,
		});

		if($termsAccepted.length) {
			$('[data-submit]').click(function() {
				that.handleSummarySubmit();
			});
		}

		window.snowdome.Alerts.init();
		window.snowdome.Forms.init();
		window.snowdome.tour.init();

		this.Promocode.init();
		this.Payment.init();
		this.handleResize();
		this.contract.init();

		$(window).on('resize', function() {
			that.handleResize();
		});

		$('#login').on('change', '.radio-wrapper input', function(e){
			var $form = $('#login');

			$form.find('[class*="password-group"]').hide().find('input').val('').prop('required', false).removeAttr('tabindex');
			$form.find('.password-group--' + e.currentTarget.value).show().find('input').prop('required', true).prop('tabindex', "3");
		});

		//Allow user to interrupt auto-scrolling
		$(document).bind('scroll mousedown wheel keyup', function(e) {
			if(e.which || e.type === 'mousedown' || e.type === 'mousewheel') {
				$(document.scrollingElement).stop();
			}
		});
	},

	handleResize: function() {
		'use strict';

		if($sidebar.length && !Modernizr.csspositionsticky) {
			if($(window).width() > 1024) {
				$sidebar.css('top', 0);
				$sidebar.css('width', 'auto');
				$sidebar.css('width', $sidebar.outerWidth());
				$sidebar.affix({
					offset: {
						top: $sidebar.offset().top,
						bottom: function() {
							return (this.bottom = $('#site-footer').outerHeight(true) + 170);
						},
					},
				});
			} else {
				$sidebar.affix('destroy');
			}
		}

		if($(window).width() < 1025) {
			$('.tabs').each(function() {
				if(!$(this).find('.active').length)
					return true;

				var offset = $(this).find('.active').offset().left - $(this).offset().left;
				$(this).animate({scrollLeft: offset}, 400);
			});
		}
	},

	handleSummarySubmit: function() {
		'use strict';

		if($termsAccepted.prop('checked')) {
			return;
		}

		if((!termsAlert || !termsAlert.open) && $(window).width() > 1024) {
			termsAlert = window.snowdome.Alerts.showError('You have to agree to the Terms and Conditions before you continue');
		}
	},

	Payment: {
		init: function() {
			'use strict';

			$('#card').change(function(e) {
				if(e.target.value === 'new') {
					$('.form__group--new-card').each(function() {
						$(this).show();
						$(this).children('.form__control').prop('disabled', false);
					});
				} else {
					$('.form__group--new-card').each(function() {
						$(this).hide();
						$(this).children('.form__control').prop('disabled', true);
					});
				}

				$('#cvv, #checkout__pay').show();
			});
		},
	},
	contract: {
		init: function(){
			var _self = this;

			_self.signature();
			_self.countdown();
			setInterval( _self.countdown, 2000);

		},
		countdown: function(){
			let date = moment().format("HH:mm DD/MM/YY");
			$('#customer-signature .time').text(date);
		},
		signature: function() {
			var $input = $('#fullname');

			if(!$input.length)
				return false;

			$('#customer-signature .signature').text($input[0].value);

			$input.on('keyup', function(e){
				$('#customer-signature .signature').text(this.value);
			});
		}
	}
};

require('./lib/bootstrap-affix.js');
require('./lib/modernizr-custom.js');
require('./lib/chosen.jquery.js');
require('remodal');
var moment = require('moment');

window.snowdome.pikadayi18n = require('./lib/pikaday-i18n.js');
window.snowdome.Alerts = require('./lib/alerts.js');
window.snowdome.Forms = require('./lib/forms.js');
window.snowdome.tour = require('./lib/tour.js');
window.snowdome.Checkout.Promocode = require('./checkout/promocode.js');
window.snowdome.Vouchers = require('./lib/vouchers.js');

jQuery(document).ready(function() {
	'use strict';
	window.$ = jQuery;
	window.snowdome.Checkout.init();
});
